module.exports = __webpack_public_path__ + "img/optical4.15bf1b24.jpeg";